var _style, _path, _g, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIronDeficiency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B9CFC0;}\n\t.st1{fill:#418133;}\n\t.st2{fill:#1A682F;}\n\t.st3{fill:#73B657;}\n\t.st4{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.4,180.3c42.8,0.2,77.7-34.1,77.9-76.5c0.2-42.4-34.4-77-77.2-77.2s-77.7,34.1-77.9,76.5 C28,145.5,62.5,180.1,105.4,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.2,76.9c-2.6-4-7.6-19.5-18.2-16.6c-6,1.6-9.1,12-6.1,22.4c2.3,8.2,7.8,15.1,5.5,17.6 c-2.4,2.5-4.5,7.4,0.4,10.9c4.9,3.4,16.3,6.6,27.3,8.9c0,0,5.7-17.4,3.9-23.1C102,91.2,93.8,80.9,91.2,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.9,79.1c-1.1-1.5-2-2.7-2.6-3.6c-0.4-0.6-1-1.7-1.6-3c-2.8-5.6-7.6-15.1-16.2-15.1 c-1.1,0-2.2,0.1-3.3,0.5c-2.7,0.7-4.9,2.6-6.6,5.6c-2.9,5.2-3.5,12.9-1.4,20.1c1,3.4,2.4,6.5,3.7,9.2c1,2.1,2.3,5,2.3,6 c-2.2,2.4-3.4,5.5-3.1,8.3c0.2,1.8,1,4.3,4,6.4c6.1,4.3,20.3,7.7,28.2,9.3l2.3,0.5l0.7-2.2c1-3,5.9-18.6,3.9-24.8 C104.8,91.4,99.7,84.3,95.9,79.1z M98.2,117c-11.7-2.5-20.3-5.4-23.9-8c-1.1-0.8-1.7-1.7-1.8-2.6c-0.2-1.6,0.9-3.3,1.8-4.3 c2.7-2.8,0.7-6.9-1.5-11.7c-1.2-2.5-2.5-5.4-3.4-8.4c-1.7-5.8-1.3-12.1,0.9-16.1c0.6-1.2,1.8-2.6,3.3-3.1 c0.7-0.2,1.3-0.3,1.9-0.3c5.4,0,9.1,7.4,11.5,12.2c0.7,1.4,1.3,2.7,1.9,3.5c0.6,1,1.6,2.3,2.7,3.8c3.3,4.6,8.4,11.6,9.7,15.6 C102.3,100.8,100.3,110.1,98.2,117z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,73.1c-7.2,3.8-14,17.2-16.7,21.2c0,0-3.4-3.6-4.5,2.6c-1.2,6.1-0.2,21.8-0.6,26.4 c0,0,7.9-5.3,18.2-10.5c10-5.1,10.2-13,12.1-25.9C144.6,74,141.2,69.4,134.1,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.9,70.8c-6.5,3.4-12.3,13.2-15.8,19c-0.2,0.3-0.4,0.7-0.6,1c-0.4-0.1-0.7-0.1-1.1-0.2 c-1.5,0-4.1,0.7-5.1,5.7c-0.8,4.1-0.7,11.5-0.6,18c0.1,3.6,0.1,7,0,8.6l-0.5,5.5l4.6-3.1c0.1-0.1,7.9-5.3,18-10.4 c10.3-5.2,11.4-13.3,13-24.5c0.2-1.1,0.3-2.2,0.5-3.4c1.2-7.7,0.6-12.9-1.9-15.7C141.1,68.8,137.3,68.5,132.9,70.8z M140.1,86.5 c-0.2,1.2-0.3,2.3-0.5,3.4c-1.5,10.7-2.4,16.5-10.2,20.5c-5.9,3-11,6-14.3,8c0-1.2,0-2.6-0.1-4c-0.1-6-0.2-13.4,0.5-17 c0.1-0.4,0.2-0.8,0.2-1l2.1,2.2l1.8-2.8c0.5-0.8,1.2-1.9,2-3.3c3-5,8.5-14.3,13.7-17.1c1.5-0.8,2.5-1,3-1c0.6,0,0.8,0.2,1.1,0.5 C139.9,75.5,141.3,78,140.1,86.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.7,76.3c-0.5-0.8-1.6-1.1-2.4-0.6c-0.8,0.5-1.1,1.6-0.6,2.4c0.3,0.5,26.9,46.2,26.4,69.4l-0.1,12.9 c0,1,0.8,1.7,1.7,1.8c1,0,1.7-0.8,1.8-1.7l0.1-12.9C108.1,123.4,81.8,78.2,80.7,76.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.5,101.6c-0.9,0.2-1.6,1.1-1.4,2c0.2,0.9,1.1,1.6,2,1.4c0.1,0,10.7-1.8,12.9,3.3c0.3,0.7,0.9,1.1,1.6,1.1 c0.2,0,0.5,0,0.7-0.1c0.9-0.4,1.3-1.4,0.9-2.3C93,99.2,80.1,101.5,79.5,101.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.2,86.5c-0.8-0.5-1.9-0.3-2.4,0.5c-2.8,4.1-27,40.5-26.3,51.4l0.1,22c0,1,0.8,1.7,1.7,1.7c0,0,0,0,0,0 c1,0,1.7-0.8,1.7-1.8l-0.2-22.1c-0.6-8.3,18.3-38.4,25.7-49.3C135.2,88.1,135,87,134.2,86.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.9,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronDeficiency);
export default __webpack_public_path__ + "static/media/Iron_Deficiency.debdb7e85a5676d24b6f7e360a98c8b7.svg";
export { ForwardRef as ReactComponent };